//import Components
import {CSSProperties, useEffect, useState} from "react";


//Component styling

//----------------[Component - PageLoading]---------------------//
//render
type props = {
  containerStyle?: CSSProperties,
  spinnerStyle?: CSSProperties,
  text?: string,
}


export default function PageLoading({text, containerStyle, spinnerStyle}: props) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setTimeout(() => setShow(true), 0);
  }, [])


  if (show) {
    return (
      <div className="loading" style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        ...containerStyle,
      }}>
        {/*Loading Component - spinning dots*/}
        <div className={"loading-spinner"} style={spinnerStyle}/>
        <span style={{marginTop: "3rem"}}>
                            {/*Descriptive text for loading screen*/}
          <p className={"fs3"}>{text}</p>
                            </span>
      </div>
    );
  } else {
    return null;
  }
}
